/* ==========================================================================
  accordion-faq.js
========================================================================== */

"use strict";

/* global Accordion */

/**
 * Handle FAQ accordions
 *
 * @returns void
 */
const accordionsFaq = () => {

  const accordions = document.querySelectorAll(".accordion-faq");

  if (!accordions) {
    return;
  }

  accordions.forEach((accordion) => {
    new Accordion(accordion, {
      duration: 400,
      showMultiple: false,
      elementClass: "teaser-faq",
      triggerClass: "teaser-faq__header",
      panelClass: "teaser-faq__panel",
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  accordionsFaq();
});
